import React from 'react';

const WizardSteps = ({ currentStep, onChange, legalSteps=0 }) => {
  const steps = [
    { number: 1, label: 'Відомості про дитину' },
    { number: 2, label: 'Відомості про заявника' },
    { number: 3, label: 'Додаткові побажання' },
    { number: 4, label: 'Наявність пільг' },
    { number: 5, label: 'Обрання садочку' },
    { number: 6, label: 'Погодження з умовами' }
  ];

  return (
    <div className="wizard-steps">
      {steps.map((step, index) => (
        <div
          key={step.number}
          className={`wizard-step ${(legalSteps >= step.number && step.number !== currentStep) || (currentStep > step.number) ? 'completed' : ''} ${currentStep === step.number ? 'active' : ''}`}
          onClick={()=>onChange(step.number)}
        >
          <div className="circle">{currentStep > step.number ? '' : step.number}</div>
          <div className="label">{step.label}</div>
        </div>
      ))}
    </div>
  );
};

export default WizardSteps;